module.exports = __webpack_public_path__ + "static/media/LK_Download.2fdb5708.svg";